import { GenericAbortSignal } from 'axios';

import { DenialListItem } from 'models/DenialListItem';
import { Paginated } from 'models/Paginated';
import { DenialListItemMutationParams } from 'services/api/denialListItems';
import { BaseIndexQueryParams } from 'services/api/types';
import http from 'services/http';

export type AdminDenialListItemsIndexParams = BaseIndexQueryParams;

// Same five writable fields as the customer mutation, plus clientId so the admin endpoint can
// resolve the target client's active list.
export type AdminDenialListItemMutationParams = DenialListItemMutationParams & {
  clientId: string;
};

export const adminDenialListItemQueryKeys = {
  base: ['adminDenialListItems'],
  index: (denialListId: string, params: Record<string, any> = {}) => [
    'adminDenialListItems',
    'index',
    denialListId,
    params,
  ],
};

export async function indexAdminDenialListItems(
  denialListId: string,
  params: AdminDenialListItemsIndexParams,
  signal?: GenericAbortSignal
) {
  return http
    .get<Paginated<DenialListItem>>(`/admin/denial_lists/${denialListId}/denial_list_items`, { params, signal })
    .then((response) => response.data);
}

export async function createAdminDenialListItem(params: AdminDenialListItemMutationParams) {
  return http.post<DenialListItem>('/admin/denial_list_items', params).then((response) => response.data);
}

export async function updateAdminDenialListItem({ id, ...params }: DenialListItemMutationParams & { id: string }) {
  return http.patch<DenialListItem>(`/admin/denial_list_items/${id}`, params).then((response) => response.data);
}

export async function destroyAdminDenialListItem({ id }: { id: string }) {
  return http.delete(`/admin/denial_list_items/${id}`);
}
